const getDuplicateHrefFromForm = (form) => {
  const url = new URL(form.getAttribute('action') || '', window.location.href);
  const merged = new URLSearchParams(url.search);
  const formParams = new URLSearchParams(new FormData(form));
  const qs = new URLSearchParams([...merged, ...formParams]).toString();
  return `${url.pathname}?${qs}`;
};

$(document).on('change', 'form[data-link-submit="true"]', function (e) {
  const form = e.currentTarget;
  const href = getDuplicateHrefFromForm(form);
  $(form).find('a.submit-link').attr('href', href || '#');
});

